var reissueUrl = "https://www.realestate.com.au/login/reissue";

var fetchReIssue = function fetchReIssue() {
  return fetch("".concat(reissueUrl), {
    method: 'POST',
    credentials: 'include'
  });
};

var throwErrorWhenNotOk = function throwErrorWhenNotOk(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
};

var fetchAuthenticated = function fetchAuthenticated(ajaxCall) {
  return ajaxCall().then(function (response) {
    if (response.status === 401) {
      return fetchReIssue().then(throwErrorWhenNotOk).then(ajaxCall);
    }

    return response;
  });
};

export default fetchAuthenticated;
//# sourceMappingURL=fetchAuthenticated.js.map